import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

interface ICustomTabPanelProps {
    children:React.ReactNode; 
    value:number; 
    index:number; 
}

interface ICustomeTabsProps {
    labels: string[];
    TabContents: React.ReactNode[]
}

function CustomTabPanel(props: ICustomTabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>{children}</Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index:number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function BasicTabs({labels, TabContents}:ICustomeTabsProps) {
    const [value, setValue] = React.useState(0);

    const handleChange = (event:any, newValue:number) => {
        setValue(newValue);
    };
    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', position:'sticky', top:'-12px', zIndex:'99', background:'#fff' }}>
                <Tabs variant='fullWidth' value={value} onChange={handleChange}>
                    {labels.map((label, index) => {
                        return <Tab label={label} {...a11yProps(0)} key={`tab_${index}`}/>
                    })}
                </Tabs>
            </Box>
            {TabContents.map((TabContent, index) => {
                return (
                    <CustomTabPanel index={index} value={value} key={`tabContent_${index}`}>
                    {TabContent}
                </CustomTabPanel>
                )
            })}
        </Box>
    );
}
